$(document).on('ready', function() {
  /* global ajax */
  // All Posts
  let $postsContainer = $('#all-posts-container');
  let $postsPrev = $('.posts-pagination__prev');

  let maxPages = $postsContainer.data('max-pages');
  let currentPage = 1;
  let postType = '';
  let homePage = '';

  $('body #all-posts-container').on(
    'click',
    '.posts-pagination__next',
    function() {
      if (currentPage + 1 <= maxPages) {
        $postsPrev.removeClass('link--inactive');
        currentPage++;
        paginateMultiplePosts();
      }
    }
  );

  $('body #all-posts-container').on(
    'click',
    '.posts-pagination__prev',
    function() {
      if (currentPage - 1 >= 0) {
        currentPage--;
        paginateMultiplePosts();
      }
    }
  );

  function paginateMultiplePosts() {
    var data = {
      action: 'paginate_multiple',
      nonce: ajax.nonce,
      page: currentPage,
    };

    $.ajax({
      url: ajax.url,
      type: 'POST',
      data: data,
      success: function(resp) {
        $postsContainer.html(resp);
        $('body .card').matchHeight();
      },
      error: function(err) {
        console.log(err);
      },
    });
  }
  // Tabs
  let $tab = $('#news-tabs a');
  let $tabHome = $('#news-home-tabs a');

  $tab.on('click', function() {
    currentPage = 1;
    $postsContainer.remove();
    postType = $(this).data('post-type');
    getPosts();
  });

  $tabHome.on('click', function() {
    currentPage = 1;
    $postsContainer.remove();
    postType = $(this).data('post-type');
    homePage = $(this).data('page');
    $('.tabs-panel').html('');
    getPosts(-1);
  });

  $('body #corporate_news').on('click', '.posts-pagination__next', function() {
    maxPages = $(this).data('max-pages');
    if (currentPage + 1 <= maxPages) {
      currentPage++;
      getPosts();
    }
  });

  $('body #corporate_news').on('click', '.posts-pagination__prev', function() {
    if (currentPage - 1 >= 0) {
      currentPage--;
      getPosts();
    }
  });

  $('body #press_release').on('click', '.posts-pagination__next', function() {
    maxPages = $(this).data('max-pages');
    if (currentPage + 1 <= maxPages) {
      currentPage++;
      getPosts();
    }
  });

  $('body #press_release').on('click', '.posts-pagination__prev', function() {
    if (currentPage - 1 >= 0) {
      currentPage--;
      getPosts();
    }
  });

  $('body #event').on('click', '.posts-pagination__next', function() {
    maxPages = $(this).data('max-pages');
    if (currentPage + 1 <= maxPages) {
      currentPage++;
      getPosts();
    }
  });

  $('body #event').on('click', '.posts-pagination__prev', function() {
    if (currentPage - 1 >= 0) {
      currentPage--;
      getPosts();
    }
  });

  // AJAX Function
  function getPosts(posts_per_page) {
    var data = {
      action: 'ajax_get_posts',
      nonce: ajax.nonce,
      type: postType,
      page: currentPage,
      posts_per_page: posts_per_page || 3,
      home: homePage,
    };

    $.ajax({
      url: ajax.url,
      type: 'POST',
      data: data,
      success: function(resp) {
        $('body #blog_posts').html('');
        $('body #' + postType).html(resp);
        //console.log('ajax processing type: ' + postType); //*****
        if (homePage) {
          let currSlide = $('body .home-posts-wrapper__slider--refresh');

          currSlide.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
            rows: 0,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '110px',
                  infinite: false,
                  adaptiveHeight: true,
                },
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '0px',
                  adaptiveHeight: true,
                },
              },
            ],
          });
        }
        $('body .card').matchHeight();
        if (postType == 'blog_posts') $('#blog_posts.tabs-panel').show();
      },
      error: function(err) {
        console.log(err);
      },
    });
  }
});
